import React, { useEffect, useState } from 'react';
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import { setCustomAlert } from '@redux/actions/general';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import CustomButton from '@components/Button/Button';
import InputField from '@components/Input/Input';

const StripeForm = ({ handler, loading, setLoading, dialogAction }) => {
  const stripe = useStripe();
  const element = useElements();
  const [fields, setFields] = useState({
    cardName: false,
    cardNumber: false,
    cardExpiry: false,
    cardCvc: false,
  });
  const [error, setError] = useState(true);
  useEffect(() => {
    for (const key in fields) {
      if (!fields[key]) {
        setError(true);
        break;
      }
      setError(false);
    }
  }, [fields]);

  const dispatch = useDispatch();
  const handleSubmission = async (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    if (stripe) {
      try {
        setLoading(true);
        const cardElement = await element.getElement('cardNumber');
        const response = await stripe.createPaymentMethod({
          type: 'card',
          card: cardElement,
          billing_details: {
            name: 'lll',
          },
        });
        handler(response);
      } catch (error) {
        // handler(error);
        dispatch(
          setCustomAlert({
            message: error?.message || 'Something went wrong',
            state: true,
            type: 'error',
          })
        );
      }
    }
  };

  const handleChange = (event) => {
    if (event?.target?.name === 'cardName') {
      const { name, value } = event.target;
      setFields({ ...fields, [name]: value });
    } else {
      const { elementType, complete } = event;
      setFields({ ...fields, [elementType]: complete });
    }
  };

  return (
    <form onSubmit={handleSubmission}>
      <div className='pb-1'>
        <label
          className='font-bold text-custom-font-color '
          htmlFor='card-number'
        >
          NAME ON CARD
        </label>
      </div>
      <InputField
        autoFocus
        placeholder='John Doe'
        value={fields?.cardName ? fields?.cardName : ''}
        name='cardName'
        getValue={handleChange}
        size='small'
      />
      <div className='pb-1 pt-2'>
        <label
          className='font-bold text-custom-font-color '
          htmlFor='card-number'
        >
          CARD NUMBER
        </label>
      </div>
      <CardNumberElement
        onChange={handleChange}
        className='border rounded p-3'
        id='card-number'
      />
      <div className='pt-2 pb-1'>
        <label
          className='font-bold text-custom-font-color '
          htmlFor='card-expiry'
        >
          EXPIRATION DATE
        </label>
      </div>

      <CardExpiryElement
        onChange={handleChange}
        className='border rounded p-3'
        id='card-expiry'
      />
      <div className='pt-2 pb-1'>
        <label className='font-bold text-custom-font-color ' htmlFor='card-cvc'>
          CVC
        </label>
      </div>
      <CardCvcElement
        className='border rounded p-3'
        onChange={handleChange}
        id='card-cvc'
      />
      <div className='pb-2 pt-5 flex gap-5 justify-between'>
        {dialogAction ? (
          <div className={`w-[${dialogAction?.customBtn?.width}]`}>
            <CustomButton
              variant='contained'
              btnColor='blue'
              fullWidth
              onClick={dialogAction?.customBtn?.handler}
              style={{
                color: 'white',
                padding: '8px 30px',
                fontSize: '16px',
                fontWeight: '600',
                minHeight: 45,
              }}
            >
              {dialogAction?.customBtn?.text}
            </CustomButton>
          </div>
        ) : null}
        <div
          className={`${
            dialogAction?.defaultBtn
              ? `w-[${dialogAction?.defaultBtn.width}]`
              : `w-[100%]`
          }`}
        >
          <CustomButton
            disabled={error}
            variant='contained'
            btnColor='blue'
            loading={loading}
            fullWidth
            style={{
              color: 'white',
              padding: '8px 30px',
              fontSize: '16px',
              fontWeight: '600',
              minHeight: 45,
            }}
            type='submit'
          >
            {dialogAction?.defaultBtn?.text || 'Submit'}
          </CustomButton>
        </div>
      </div>
    </form>
  );
};

export default StripeForm;

StripeForm.propTypes = {
  handler: PropTypes.func,
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  dialogAction: PropTypes.object,
};
